export default __webpack_public_path__ + "static/media/men-icon.e73b79f3.svg";